import { EStarRating } from '../../../JsonQuery';

export const starRatingLabels: Record<EStarRating, string> = {
  [EStarRating.NoRating]: 'Без звёзд',
  [EStarRating.Star1]: '1 звезда',
  [EStarRating.Star2]: '2 звезды',
  [EStarRating.Star3]: '3 звезды',
  [EStarRating.Star4]: '4 звезды',
  [EStarRating.Star5]: '5 звёзд',
};
